import { render, staticRenderFns } from "./PublicTab.vue?vue&type=template&id=6c1c8f92&scoped=true&"
import script from "./PublicTab.vue?vue&type=script&lang=js&"
export * from "./PublicTab.vue?vue&type=script&lang=js&"
import style0 from "./PublicTab.vue?vue&type=style&index=0&id=6c1c8f92&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6c1c8f92",
  null
  
)

export default component.exports